export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

interface Props {
    datetime1?: string | null
    datetime2?: string | null
}

export default class extends Component<Props> {
    static template = template;
    static defaults() {
        return {
            datetime1: null,
            datetime2: null
        } as Props;
    }
}